'use es6';

const scriptLoaded = {};
export default ((src, attrs = {}) => {
  return new Promise((resolve, reject) => {
    if (scriptLoaded[src]) {
      resolve();
      return;
    }
    const script = document.createElement('script');
    script.onload = () => {
      scriptLoaded[src] = true;
      resolve();
    };
    script.onerror = error => reject(error);
    Object.keys(attrs).forEach(attrName => {
      script.setAttribute(attrName, attrs[attrName]);
    });
    script.src = src;
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  });
});